// IMPORTS
// Modules
import { useState, useEffect } from 'react';
import $ from 'jquery';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import { OHSFormSubmit, OHSFormSelectBuilder } from '../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './CustomQuery.scss';
import { defaultFieldOptions, resultModel } from './_variables';
import Result from './Modules/Result';


// COMPONENT
export default function CustomQuery (props) {
   // States and Variables
   const [fields, setFields] = useState([]);
   const [matchingMethod, setMatchingMethod] = useState("ALL");
   const [parameters, setParameters] = useState([{
      index: 0,
      field: "name",
      comparison: "equals",
      value: ""
   }]);
   const [results, setResults] = useState(null);
   const [resultPopups, setResultPopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Custom Query"); // set page title
      getFields();
   }, []);

   // Functions
   const getFields = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'GET',
         success: function (data) {
            // Build Out Fields
            var master = [...defaultFieldOptions]; // must append defaults like this to prevent duplication in DOM
            data.forEach(function (item, i) {
               master.push({
                  id: item.id,
                  name: item.name
               });
            });
            setFields(master);

            // Dynamically Build Port Model
            data.forEach(function (field, i) {
               resultModel[field.id] = {
                  'title': field.name,
                  'display': true
               };
            });
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const executeQuery = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/customquery',
         method: 'POST',
         payload: buildPayload(),
         success: function (data) {
            setResults(OHSListDataFormatter(data, resultModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const toggleMatchingMethod = function () {
      if (matchingMethod === "ALL") {
         setMatchingMethod("ANY");
      } else {
         setMatchingMethod("ALL");
      }
   }
   const buildPayload = function () {
      // States and Variables
      var master = {};

      // Append Data
      master['matchingmethod'] = matchingMethod;
      master['sorting'] = $("#oneport-customquery-sorting").val();
      master['parameters'] = [...parameters];

      // Return Data
      return JSON.stringify(master);
   }
   const addParameter = function () {
      setParameters([...parameters, {
         index: Math.floor(Math.random() * 999999999),
         field: "name",
         comparison: "equals",
         value: null
      }]);
   }
   const updateParameter = function (id) {
      var temp = [...parameters];
      parameters.forEach(function (parameter, i) {
         if (parameter.index === id) {
            temp[i].field = $("#oneport-customquery-parameter-field-" + id).val();
            temp[i].comparison = $("#oneport-customquery-parameter-comparison-" + id).val();
            temp[i].value = $("#oneport-customquery-parameter-input-" + id).val();
         }
      });
      setParameters([...temp]);
   }
   const deleteParameter = function (id) {
      var temp = [...parameters];
      parameters.forEach(function (parameter, i) {
         if (parameter.index === id) {
            temp.splice(i, 1);
         }
      });
      setParameters([...temp]);
   }

   // Component
   return (
      <div className="oneport-customquery">
         <OHSAppHeader onehive={props.onehive} title="Custom Query" help="https://www.onehivesystems.com/documentation/oneport/customquery" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='oneport-customquery-buildquery' title="Build Query" onEnter={executeQuery}>
               <div className='oneport-customquery-matchingmethod'>
                  <button className='ohsbtn' onClick={toggleMatchingMethod}>Switch</button>
                  <p>Matching Rule: <b>{matchingMethod}</b></p>
               </div>
               <div className='oneport-customquery-sorting'>
                  <p>Sort by: </p>
                  <OHSFormSelectBuilder onehive={props.onehive} id="oneport-customquery-sorting" content={fields} object={true} objectValue="id" objectName="name" blank={false} />
               </div>
               <div id="oneport-customquery-parameters" className='oneport-customquery-parameters'>
                  {parameters && parameters.length > 0 && parameters.map(function (parameter, i) {
                     return (
                        <div key={`oneport-customquery-parameter-${parameter.index}`} id={`oneport-customquery-parameter-${parameter.index}`} className='oneport-customquery-parameter'>
                           <div className='oneport-customquery-parameter-field'>
                              <OHSFormSelectBuilder onehive={props.onehive} id={`oneport-customquery-parameter-field-${parameter.index}`} content={fields} object={true} objectName="name" objectValue="id" selected={parameter.field} blank={false} onchange={() => {updateParameter(parameter.index);}} />
                           </div>
                           <div className='oneport-customquery-parameter-comparison'>
                              <OHSFormSelectBuilder onehive={props.onehive} id={`oneport-customquery-parameter-comparison-${parameter.index}`} content={["equals", "does not equal", "contains", "does not contain"]} simple={true} selected={parameter.comparison} blank={false} onchange={() => {updateParameter(parameter.index);}} />
                           </div>
                           <div className='oneport-customquery-parameter-input'>
                              <input id={`oneport-customquery-parameter-input-${parameter.index}`} className='ohsinput' type='text' placeholder='--- value ---' defaultValue={parameter.value} onChange={() => {updateParameter(parameter.index);}} />
                           </div>
                           {parameters.length !== 1 &&
                              <div className='oneport-customquery-parameter-delete'>
                                 <button className='ohsbtn-error' onClick={() => {deleteParameter(parameter.index);}}>-</button>
                              </div>
                           }
                        </div>
                     );
                  })}
               </div>
               <div className='oneport-customquery-addparameter'>
                  <button className='ohsbtn' onClick={addParameter}>Add Parameter</button>
               </div>
               <OHSFormSubmit onehive={props.onehive} custom={[
                  {
                     title: "Run Query",
                     action: executeQuery,
                     class: "ohsbtn-success"
                  }
               ]} keyListener={true} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Results" container="oneport-customquery-list" />
            <OHSWidget onehive={props.onehive} id="oneport-customquery-list" title="List of Results" className="oneport-customquery-list">
               <div className='oneport-customquery-list-resultscounter'>
                  <p>Number of Matched Ports: {results ? results.length : 0}</p>
               </div>
               <OHSList onehive={props.onehive} content={results} popups={resultPopups} setPopups={setResultPopups} template={
                  <Result onehive={props.onehive} parent={{
                     fields: fields
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}